export const UserOptions = {
	ORDER_OVERVIEW_PORTAL: 'ORDER_OVERVIEW_PORTAL',
	ORDER_PORTAL: 'ORDER_PORTAL',
};

export type UserOptionsType = (typeof UserOptions)[keyof typeof UserOptions];
